import React, { useState, useEffect } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'moment/locale/pt-br';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import cacheManager from '../CacheManager';
import 'bootstrap/dist/css/bootstrap.min.css';

moment.locale('pt-br');

const localizer = momentLocalizer(moment);

const messages = {
    allDay: 'Dia inteiro',
    previous: 'Anterior',
    next: 'Próximo',
    today: 'Hoje',
    month: 'Mês',
    week: 'Semana',
    day: 'Dia',
    agenda: 'Agenda',
    date: 'Data',
    time: 'Hora',
    event: 'Evento',
    noEventsInRange: 'Não há eventos neste intervalo.',
    showMore: total => `+ Ver mais (${total})`
};

const PgAgenda = () => {
    const [events, setEvents] = useState([]);
    const [filteredAgendamentos, setFilteredAgendamentos] = useState([]);
    const [selectedEspaco, setSelectedEspaco] = useState('All');
    const [itensById, setItensById] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                setIsLoading(true);
                
                // Buscar agendamentos e itens
                const data = await cacheManager.getAgendamentosCache();
                const itemsData = await cacheManager.getItensById();
                setItensById(itemsData);
                
                // Filtrar agendamentos dos últimos 8 meses
                let eightMonthsAgo = new Date();
                const currentMonth = eightMonthsAgo.getMonth();
                const targetMonth = currentMonth - 8;

                if (targetMonth < 0) {
                    eightMonthsAgo.setFullYear(eightMonthsAgo.getFullYear() - 1);
                    eightMonthsAgo.setMonth(12 + targetMonth);
                } else {
                    eightMonthsAgo.setMonth(targetMonth);
                }

                const formattedEvents = data
                    .filter(agendamento => ((new Date(agendamento.data_inicio_agendamento)) >= eightMonthsAgo))
                    .map(agendamento => ({
                        title: itemsData[agendamento.id_item]?.titulo || 'Evento',
                        start: new Date(agendamento.data_inicio_agendamento),
                        end: new Date(agendamento.data_fim_agendamento),
                        id_item: agendamento.id_item,
                        id_espaco: itemsData[agendamento.id_item]?.id_espaco,
                    }));
                
                setEvents(formattedEvents);
                setFilteredAgendamentos(formattedEvents);
            } catch (error) {
                console.error('Erro ao buscar agendamentos:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchEvents();
    }, []);

    useEffect(() => {
        if (selectedEspaco === 'All') {
            setFilteredAgendamentos(events);
        } else if (selectedEspaco === '8') {
            // Estações individuais de trabalho (múltiplos espaços)
            setFilteredAgendamentos(events.filter(event => 
                ['8', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32'].includes(event.id_espaco)
            ));
        } else {
            setFilteredAgendamentos(events.filter(event => event.id_espaco === selectedEspaco));
        }
    }, [selectedEspaco, events]);

    if (isLoading) {
        return (
            <div className="container mt-5 text-center">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Carregando...</span>
                </div>
            </div>
        );
    }

    return (
        <div className="container-fluid mt-4">
            <div className="row mb-4">
                <div className="col-12">
                    <h2>Agenda de Eventos</h2>
                    <p className="text-muted">Visualize todos os agendamentos dos últimos 8 meses</p>
                </div>
            </div>

            {/* Filtros de Espaço */}
            <div className="row mb-3">
                <div className="col-12">
                    <div className="btn-group flex-wrap" role="group" aria-label="Filtro por Espaço">
                        <input type="radio" className="btn-check" name="btnradio" id="btnradioAll" autoComplete="off" value="All" checked={selectedEspaco === 'All'} onChange={(e) => setSelectedEspaco(e.target.value)} />
                        <label className="btn btn-outline-primary" htmlFor="btnradioAll">Todos</label>

                        <input type="radio" className="btn-check" name="btnradio" id="btnradio4" autoComplete="off" value="4" checked={selectedEspaco === '4'} onChange={(e) => setSelectedEspaco(e.target.value)} />
                        <label className="btn btn-outline-primary" htmlFor="btnradio4">Salão Jatiúca</label>

                        <input type="radio" className="btn-check" name="btnradio" id="btnradio5" autoComplete="off" value="5" checked={selectedEspaco === '5'} onChange={(e) => setSelectedEspaco(e.target.value)} />
                        <label className="btn btn-outline-primary" htmlFor="btnradio5">Salão Murici</label>

                        <input type="radio" className="btn-check" name="btnradio" id="btnradio6" autoComplete="off" value="6" checked={selectedEspaco === '6'} onChange={(e) => setSelectedEspaco(e.target.value)} />
                        <label className="btn btn-outline-primary" htmlFor="btnradio6">Sala 1</label>

                        <input type="radio" className="btn-check" name="btnradio" id="btnradio7" autoComplete="off" value="7" checked={selectedEspaco === '7'} onChange={(e) => setSelectedEspaco(e.target.value)} />
                        <label className="btn btn-outline-primary" htmlFor="btnradio7">Sala 2</label>

                        <input type="radio" className="btn-check" name="btnradio" id="btnradio8" autoComplete="off" value="8" checked={selectedEspaco === '8'} onChange={(e) => setSelectedEspaco(e.target.value)} />
                        <label className="btn btn-outline-primary" htmlFor="btnradio8">Estações de Trabalho</label>

                        <input type="radio" className="btn-check" name="btnradio" id="btnradio33" autoComplete="off" value="33" checked={selectedEspaco === '33'} onChange={(e) => setSelectedEspaco(e.target.value)} />
                        <label className="btn btn-outline-primary" htmlFor="btnradio33">Sala 3</label>

                        <input type="radio" className="btn-check" name="btnradio" id="btnradio34" autoComplete="off" value="34" checked={selectedEspaco === '34'} onChange={(e) => setSelectedEspaco(e.target.value)} />
                        <label className="btn btn-outline-primary" htmlFor="btnradio34">Sala 4</label>
                    </div>
                </div>
            </div>

            {/* Calendário */}
            <div className="row">
                <div className="col-12">
                    <div className="card border-0 shadow-sm">
                        <div className="card-body p-4">
                            <Calendar
                                localizer={localizer}
                                events={filteredAgendamentos}
                                startAccessor="start"
                                endAccessor="end"
                                style={{ height: 600 }}
                                messages={messages}
                                formats={{
                                    dateFormat: 'DD/MM/YYYY',
                                    dayFormat: (date, culture, localizer) =>
                                        localizer.format(date, 'ddd, DD/MM/YYYY', culture),
                                    weekdayFormat: (date, culture, localizer) =>
                                        localizer.format(date, 'ddd', culture),
                                }}
                                min={new Date(1970, 1, 1, 7, 0, 0)}
                                max={new Date(1970, 1, 1, 20, 0, 0)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PgAgenda;
